module.exports = __webpack_public_path__ + "094ef22a7883cb70a96b6ccd89126039.png";